import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { redirect } from '../../../lib/utils/browser';


const defaultDocUploadSubtitle = `SheerID is reviewing your documents, to confirm your
                        status.<br><br>This process may take up to 72 hours.`;

const defaultDocUploadSubtitle3 = 'You will be contacted via email.';

const redirectDestination = 'https://happiestbaby.co.uk/products/snoo-smart-bassinet';

const ReviewPending = ({ intl, logo, maxReviewTime }: any) => (
    <div className="sid-header sid-l-horz-center" data-testid="sid-review-pending">
        <div className="sid-l-horz-center">
            { logo }
        </div>
        <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
            <FormattedHTMLMessage id="step.pending.titleReview" defaultMessage="Reviewing" />
        </div>
        <div className="sid-header__subtitle-one">
            <FormattedHTMLMessage
                id="step.pending.subtitle"
                defaultMessage={defaultDocUploadSubtitle}
                values={{
                    maxReviewTime: intl.formatMessage({
                        id: `dateTime.${maxReviewTime}`,
                        default: '2 hours',
                    }),
                }}
            />
        </div>
        <div className="sid-header__subtitle-three sid-l-space-top-md">
            <FormattedHTMLMessage
                id="step.pending.subtitle3"
                defaultMessage={defaultDocUploadSubtitle3}
            />
        </div>
        <div className="sid-l-space-top-xl" />
        <div className="sid-submit sid-l-space-top-md">
            <button
                onClick={() => redirect(redirectDestination)}
                className="sid-btn sid-btn--dark"
            >
                <FormattedHTMLMessage id="step.pending.redirectButtonText" defaultMessage="Continue to Happiest Baby" />
            </button>
        </div>
    </div>
);

export const ReviewPendingComponent = ReviewPending;
